import logoSvg from 'assets/img/logo/logo.png';

export const Logo = ({ width = 120, height = 40 }: { width?: number; height?: number }) => {
    return <img src={logoSvg} alt="logo" width={width} height={height} />;
};
